import { observable, toJS } from 'mobx';
import TimelineEventModel from './TimelineEventModel';

export default class TimelineModel {
    id = null;

    @observable name = null;

    @observable blockId = null;

    @observable layerId = null;

    @observable events = [];

    @observable channelId = null;

    auth = null;

    constructor(auth, id, name, blockId, layerId, events, channelId, eventsCount) {
        this.auth = auth;

        this.id = id;
        this.name = name;
        this.blockId = blockId;
        this.layerId = layerId;
        this.events = events;
        this.channelId = channelId;
        this.eventsCount = eventsCount;
    }

    toJS() {
        toJS(this);
    }

    static fromJS(auth, object) {
        const events = object.events ? object.events.map(s => TimelineEventModel.fromJS(s)).reverse() : [];
        return new TimelineModel(
            auth, object.id, object.name, object.block_id, object.layer_id,
            events, object.channel_id, object.events_count,
        );
    }
}
